import { Clientes } from '@/interface/cliente.model';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { GeneralService } from '@services/general.service';
import { LoadingService } from '@services/loading.service';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-clientes-todos',
  templateUrl: './clientes-todos.component.html',
  styleUrls: ['./clientes-todos.component.scss']
})
export class ClientesTodosComponent implements OnInit {
  clientes: Clientes;
  searchForm: FormGroup;

  constructor(
    private toastr: ToastrService,
    private fb: FormBuilder,
    public generalService: GeneralService,
    private loadingService: LoadingService
  ) { }

  initializeForm() {
    this.searchForm = this.fb.group({
      search: [""],
      clienteHabilitado: [true],
    });
  }

  async ngOnInit() {
    this.initializeForm();
    await this.getData()
    this.searchForm.valueChanges.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      switchMap(query => this.generalService.getListar(`cliente/direcciones?habilitado=${this.searchForm.get('clienteHabilitado').value ? "1" : "0"}&search=${this.searchForm.get('search').value}&limit=100`))
    ).subscribe(res => {
      this.clientes = res.data;
      this.loadingService.setLoading(false)
    });
  }

  async getData() {
    try {
      this.loadingService.setLoading(true)
      let res = await this.generalService.getListar(`cliente/direcciones?habilitado=${this.searchForm.get('clienteHabilitado').value ? "1" : "0"}&search=${this.searchForm.get('search').value}&limit=100`)
      this.clientes = res.data;
      this.loadingService.setLoading(false)
    } catch (error) {
      this.toastr.error('Error al cargar clientes!')
      this.loadingService.setLoading(false)
    }
  }
}
